(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orm-collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  class OrmCollectionToolbar extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.setup, { once: true });
      } else {
        this.setup();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.setup);
      window.removeEventListener('resize', this.reflowOverflow);
      this.removeEventListener('click', this.removeFilter);
      this.removeEventListener('keydown', this.removeFilter);
      this.removeEventListener('change', this.updateSorting);
      this.observer?.disconnect();
    }

    setup = () => {
      const catalog = document.querySelector('results-list.orm-product-catalog');
      const mainSection = catalog?.closest('.shopify-section');
      if (!mainSection) return;

      this.sync();
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(mainSection, { childList: true, subtree: true });
      window.addEventListener('resize', this.reflowOverflow);
      this.addEventListener('click', this.removeFilter);
      this.addEventListener('keydown', this.removeFilter);
      this.addEventListener('change', this.updateSorting);
    };

    updateSorting = (event) => {
      const input = event.target;
      const sorting = input instanceof HTMLInputElement ? input.closest('.sorting-filter') : null;
      if (!(input instanceof HTMLInputElement) || !sorting) return;

      const status = sorting.querySelector('.orm-collection-toolbar__sort-status');
      if (status) status.textContent = input.dataset.optionName || '';

      const form = input.form?.closest('facets-form-component');
      if (!form) return;

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', input.value);
      url.searchParams.delete('page');
      form.updateFiltersByURL(`${url.pathname}${url.search}`);
    };

    removeFilter = (event) => {
      const control = event.target.closest('.orm-collection-toolbar__active-filters facet-remove-component, .orm-collection-toolbar__clear');
      if (!control) return;

      if (event instanceof KeyboardEvent && event.key !== 'Enter' && event.key !== ' ') return;
      if (event instanceof KeyboardEvent) event.preventDefault();

      const form = document.querySelector(
        'results-list.orm-product-catalog .facets-block-wrapper--vertical facets-form-component'
      );
      const url = control.dataset.url;
      if (form && url) form.updateFiltersByURL(url);
    };

    syncActiveFilters = (wrapper, controls) => {
      const activeFilters = this.querySelector('.orm-collection-toolbar__active-filters');
      const source = wrapper.querySelector('.facets-block-wrapper--vertical .facets-remove--mobile-and-vertical');
      if (!activeFilters) return;

      const pills = source ? [...source.querySelectorAll(':scope > facet-remove-component.facets-remove__pill')] : [];
      activeFilters.replaceChildren(...pills.map((pill) => pill.cloneNode(true)));

      const controlsRow = controls.find((control) => control.matches('.facets--horizontal.facets-controls-wrapper'));
      controlsRow?.querySelector('.orm-collection-toolbar__clear')?.remove();

      const sourceClear = source?.querySelector(':scope > facet-remove-component:not(.facets-remove__pill)');
      const sorting = controlsRow?.querySelector('sorting-filter-component');
      if (sourceClear && sorting) {
        const clear = sourceClear.cloneNode(true);
        clear.classList.add('orm-collection-toolbar__clear');
        const url = new URL(clear.dataset.url, window.location.origin);
        const view = new URL(window.location.href).searchParams.get('view');
        if (view) url.searchParams.set('view', view);
        clear.dataset.url = `${url.pathname}${url.search}`;
        controlsRow.insertBefore(clear, sorting);
      }
    };

    reflowOverflow = () => {
      const overflow = this.querySelector('overflow-list');
      if (!overflow) return;

      if (window.matchMedia('(min-width: 61.875rem)').matches) {
        overflow.querySelectorAll('[slot="overflow"]').forEach((item) => {
          item.slot = '';
        });
        overflow.setAttribute('disabled', 'true');
        overflow.removeAttribute('minimum-reached');
      } else {
        overflow.setAttribute('disabled', 'false');
        overflow.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
      }
    };

    sync = () => {
      const mount = this.querySelector('.orm-collection-toolbar__mount');
      const wrapper = document.querySelector('results-list.orm-product-catalog .collection-wrapper');
      if (!mount || !wrapper) return;

      const controls = [...wrapper.children].filter((child) =>
        child.matches('.facets-block-wrapper--horizontal, .facets--horizontal.facets-controls-wrapper, .facets-toggle')
      );

      if (controls.length) {
        const overflow = controls.flatMap((control) => [...control.querySelectorAll('overflow-list')])[0];
        if (overflow && window.matchMedia('(min-width: 61.875rem)').matches) {
          overflow.querySelectorAll('[slot="overflow"]').forEach((item) => {
            item.slot = '';
          });
          overflow.setAttribute('disabled', 'true');
        }

        mount.replaceChildren(...controls);
        requestAnimationFrame(() => setTimeout(this.reflowOverflow, 0));
      }

      this.syncActiveFilters(wrapper, [...mount.children]);

      mount.querySelectorAll('.sorting-filter .facets__status').forEach((status) => {
        status.classList.remove('desktop:hidden');
        status.classList.add('orm-collection-toolbar__sort-status');
      });
    };
  }

  if (!customElements.get('orm-collection-toolbar')) {
    customElements.define('orm-collection-toolbar', OrmCollectionToolbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orm-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class OrmReviewCarousel extends HTMLElement {
    async connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.scroller = this.querySelector('[data-review-scroller]');
      this.desktopQuery = window.matchMedia('(min-width: 61.875rem)');
      if (!this.scroller) return;

      const signal = this.controller.signal;
      await this.loadRandomReviews(signal);
      if (signal.aborted) return;

      this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
      if (this.cards.length === 0) return;

      this.scroller.addEventListener('scroll', this.queueUpdate, { passive: true, signal });
      this.scroller.addEventListener('keydown', this.handleKeydown, { signal });
      this.scroller.addEventListener('pointerdown', this.handlePointerDown, { signal });
      this.scroller.addEventListener('pointermove', this.handlePointerMove, { passive: false, signal });
      this.scroller.addEventListener('pointerup', this.handlePointerEnd, { signal });
      this.scroller.addEventListener('pointercancel', this.handlePointerEnd, { signal });
      this.desktopQuery.addEventListener('change', this.queueUpdate, { signal });

      this.resizeObserver = new ResizeObserver(this.queueUpdate);
      this.resizeObserver.observe(this.scroller);
      this.updateEdges();
    }

    async loadRandomReviews(signal) {
      try {
        const response = await fetch(this.dataset.reviewsUrl, { signal, credentials: 'same-origin' });
        if (!response.ok) return;

        const reviews = await response.json();
        if (!Array.isArray(reviews) || reviews.length < 6) return;

        const fragment = document.createDocumentFragment();
        this.selectRandomReviews(reviews, 6).forEach((review, index) => {
          if (index > 0) fragment.append(this.createSeparator());
          fragment.append(this.createReviewCard(review));
        });
        this.scroller.replaceChildren(fragment);
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
    }

    selectRandomReviews(reviews, count) {
      const pool = reviews.slice();
      for (let index = pool.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [pool[index], pool[randomIndex]] = [pool[randomIndex], pool[index]];
      }
      return pool.slice(0, count);
    }

    createReviewCard(review) {
      const card = document.createElement('article');
      card.className = 'orm-customer-reviews__card';
      card.dataset.reviewCard = '';
      card.dataset.reviewId = review.id;

      const rating = document.createElement('div');
      rating.className = 'orm-customer-reviews__rating';
      rating.setAttribute('aria-label', `${review.rating} out of 5 stars`);

      const stars = document.createElement('span');
      stars.className = 'orm-customer-reviews__stars';
      stars.setAttribute('aria-hidden', 'true');
      for (let index = 0; index < review.rating; index += 1) {
        const star = document.createElement('img');
        star.src = this.dataset.starUrl;
        star.alt = '';
        star.width = 17;
        star.height = 16;
        stars.append(star);
      }

      const badge = document.createElement('span');
      badge.textContent = 'Takealot review';
      rating.append(stars, badge);

      const copy = document.createElement('div');
      copy.className = 'orm-customer-reviews__copy';
      const paragraph = document.createElement('p');
      paragraph.textContent = review.review;
      copy.append(paragraph);

      const product = document.createElement('a');
      product.className = 'orm-customer-reviews__product';
      product.href = review.url;
      product.target = '_blank';
      product.rel = 'noopener noreferrer';
      product.textContent = `Reviewed product: ${review.product}`;

      const footer = document.createElement('footer');
      footer.className = 'orm-customer-reviews__footer';
      const customer = document.createElement('strong');
      customer.textContent = review.customer;
      const date = document.createElement('time');
      date.textContent = review.date;
      footer.append(customer, date);

      card.append(rating, copy, product, footer);
      return card;
    }

    createSeparator() {
      const separator = document.createElement('span');
      separator.className = 'orm-customer-reviews__separator';
      separator.setAttribute('aria-hidden', 'true');
      return separator;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.controller = null;
      this.frame = null;
    }

    queueUpdate = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(this.updateEdges);
    };

    updateEdges = () => {
      this.frame = null;
      if (!this.scroller) return;

      if (!this.desktopQuery.matches) {
        this.cards.forEach((card) => {
          card.classList.remove('is-edge-left', 'is-edge-right');
          card.style.removeProperty('--orm-review-left-bridge');
          card.style.removeProperty('--orm-review-right-bridge');
        });
        return;
      }

      const scrollerRect = this.scroller.getBoundingClientRect();
      const styles = getComputedStyle(this.scroller);
      const gutter = Number.parseFloat(styles.paddingInlineStart) || 0;
      const gap = Number.parseFloat(styles.columnGap) || 0;
      const innerLeft = scrollerRect.left + gutter;
      const innerRight = scrollerRect.right - gutter;
      const visibleCards = this.cards.filter((card) => {
        const rect = card.getBoundingClientRect();
        return rect.right > innerLeft + 1 && rect.left < innerRight - 1;
      });
      const leftCard = visibleCards[0];
      const rightCard = visibleCards[visibleCards.length - 1];
      const maxBridge = gutter + gap;

      this.cards.forEach((card) => {
        const isLeft = card === leftCard;
        const isRight = card === rightCard;
        card.classList.toggle('is-edge-left', isLeft);
        card.classList.toggle('is-edge-right', isRight);

        if (isLeft) {
          const bridge = Math.min(maxBridge, Math.max(0, card.getBoundingClientRect().left - scrollerRect.left));
          card.style.setProperty('--orm-review-left-bridge', `${bridge}px`);
        } else {
          card.style.removeProperty('--orm-review-left-bridge');
        }

        if (isRight) {
          const bridge = Math.min(maxBridge, Math.max(0, scrollerRect.right - card.getBoundingClientRect().right));
          card.style.setProperty('--orm-review-right-bridge', `${bridge}px`);
        } else {
          card.style.removeProperty('--orm-review-right-bridge');
        }
      });
    };

    handleKeydown = (event) => {
      if (!this.desktopQuery.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      this.scroller.scrollBy({ left: this.getStep() * direction, behavior: this.getScrollBehavior() });
    };

    handlePointerDown = (event) => {
      if (!this.desktopQuery.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
      if (this.scroller.scrollWidth <= this.scroller.clientWidth) return;

      this.pointerId = event.pointerId;
      this.pointerStart = event.clientX;
      this.scrollStart = this.scroller.scrollLeft;
      this.didDrag = false;
      this.scroller.setPointerCapture(event.pointerId);
    };

    handlePointerMove = (event) => {
      if (event.pointerId !== this.pointerId) return;

      const distance = event.clientX - this.pointerStart;
      if (Math.abs(distance) > 4) {
        this.didDrag = true;
        this.toggleAttribute('data-dragging', true);
      }
      if (!this.didDrag) return;

      event.preventDefault();
      this.scroller.scrollLeft = this.scrollStart - distance;
    };

    handlePointerEnd = (event) => {
      if (event.pointerId !== this.pointerId) return;

      if (this.scroller.hasPointerCapture(event.pointerId)) {
        this.scroller.releasePointerCapture(event.pointerId);
      }
      this.pointerId = null;
      this.toggleAttribute('data-dragging', false);
      if (!this.didDrag) return;

      const step = this.getStep();
      this.scroller.scrollTo({
        left: Math.round(this.scroller.scrollLeft / step) * step,
        behavior: this.getScrollBehavior(),
      });
    };

    getStep() {
      const card = this.cards[0];
      if (!card) return 0;
      const gap = Number.parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    getScrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
  }

  if (!customElements.get('orm-review-carousel')) {
    customElements.define('orm-review-carousel', OrmReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orm-faq-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    window.ormFaqNavigationController?.abort();

    const controller = new AbortController();
    const { signal } = controller;
    window.ormFaqNavigationController = controller;

    const rebuildNavigation = () => {
      const navigation = document.querySelector('[data-faq-navigation]');
      const links = navigation?.querySelector('[data-faq-navigation-links]');
      const targets = Array.from(document.querySelectorAll('[data-faq-navigation-item]')).filter((target) =>
        target.querySelector('details')
      );

      document.querySelectorAll('[data-faq-separator]').forEach((separator) => {
        separator.hidden = false;
      });

      const finalSeparators = targets.at(-1)?.querySelectorAll('[data-faq-separator]');
      if (finalSeparators?.length) finalSeparators[finalSeparators.length - 1].hidden = true;
      if (!navigation || !links) return;

      links.replaceChildren();
      navigation.hidden = targets.length === 0;

      targets.forEach((target, index) => {
        const title = target.dataset.faqTitle?.trim();
        if (!title || !target.id) return;

        const link = document.createElement('a');
        link.className = 'orm-faq-navigation__link';
        link.href = `#${target.id}`;
        link.textContent = title;
        link.dataset.faqNavigationLink = '';

        if (window.location.hash === link.hash || (!window.location.hash && index === 0)) {
          link.classList.add('is-active');
          link.setAttribute('aria-current', 'true');
        }

        links.append(link);
      });

      if (!links.querySelector('.is-active')) {
        const firstLink = links.querySelector('[data-faq-navigation-link]');
        firstLink?.classList.add('is-active');
        firstLink?.setAttribute('aria-current', 'true');
      }
    };

    const scheduleRebuild = () => window.setTimeout(rebuildNavigation);

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('[data-faq-navigation-link]');
        const navigation = link?.closest('[data-faq-navigation]');
        const target = link ? document.getElementById(link.hash.slice(1)) : null;
        if (!navigation || !target) return;

        event.preventDefault();
        navigation.querySelectorAll('[data-faq-navigation-link]').forEach((item) => {
          item.classList.remove('is-active');
          item.removeAttribute('aria-current');
        });
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'true');

        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        target.scrollIntoView({ behavior, block: 'start' });

        try {
          window.history.pushState(null, '', link.hash);
        } catch {}
      },
      { signal }
    );

    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((eventName) => {
      document.addEventListener(eventName, scheduleRebuild, { signal });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rebuildNavigation, { once: true, signal });
    } else {
      rebuildNavigation();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orm-hero-search"] && !Shopify.designMode) return;
  try {
    
  class OrmFilterDropdown extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.type = this.dataset.dropdownType;
      this.input = this.querySelector('[data-filter-input]');
      this.items = Array.from(this.querySelectorAll('[data-filter-item]'));
      this.empty = this.querySelector('[data-filter-empty]');
      this.details = this.querySelector('details');
      this.selectedLabel = this.querySelector('[data-selected-label]');
      this.controlRow = this.closest('.orm-hero-search__control-row');
      this.hasDepartmentMappings = this.items.some((item) => item.dataset.departmentHandle);
      this.departmentHandle = '';

      this.input?.addEventListener('input', this.filter, { signal: this.controller.signal });
      this.details?.addEventListener('toggle', this.handleToggle, { signal: this.controller.signal });

      if (this.type === 'department') {
        this.items.forEach((item) => {
          item.addEventListener('click', this.selectDepartment, { signal: this.controller.signal });
        });
      } else if (this.type === 'category') {
        this.controlRow?.addEventListener('orm:department-change', this.handleDepartmentChange, {
          signal: this.controller.signal,
        });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    filter = () => {
      const query = this.input?.value.trim().toLocaleLowerCase() || '';
      let visibleCount = 0;

      this.items.forEach((item) => {
        const matchesQuery = item.textContent.trim().toLocaleLowerCase().includes(query);
        const matchesDepartment =
          this.type !== 'category' ||
          !this.hasDepartmentMappings ||
          !this.departmentHandle ||
          item.dataset.departmentHandle === this.departmentHandle;
        const visible = matchesQuery && matchesDepartment;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (this.empty) this.empty.hidden = visibleCount > 0;
    };

    selectDepartment = (event) => {
      const selected = event.currentTarget;

      this.items.forEach((item) => {
        item.setAttribute('aria-pressed', String(item === selected));
      });

      const departmentTitle = selected.textContent.trim();

      if (this.selectedLabel) this.selectedLabel.textContent = departmentTitle;
      if (this.details) this.details.open = false;
      this.updateSearchFilter(departmentTitle);

      this.controlRow?.dispatchEvent(
        new CustomEvent('orm:department-change', {
          detail: { handle: selected.dataset.departmentHandle || '' },
        })
      );
    };

    updateSearchFilter(departmentTitle) {
      const predictiveSearch = this.controlRow?.querySelector('predictive-search-component');
      if (!predictiveSearch) return;

      if (typeof predictiveSearch.setDepartmentFilter === 'function') {
        predictiveSearch.setDepartmentFilter(departmentTitle);
        return;
      }

      customElements.whenDefined('predictive-search-component').then(() => {
        predictiveSearch.setDepartmentFilter?.(departmentTitle);
      });
    }

    handleDepartmentChange = (event) => {
      this.departmentHandle = event.detail.handle;
      if (this.input) this.input.value = '';
      this.filter();
      if (this.details) this.details.open = true;
    };

    handleToggle = () => {
      if (this.details?.open) {
        this.controlRow?.querySelectorAll('orm-filter-dropdown details[open]').forEach((details) => {
          if (details !== this.details) details.open = false;
        });
        return;
      }

      if (!this.input) return;
      this.input.value = '';
      this.filter();
    };
  }

  if (!customElements.get('orm-filter-dropdown')) {
    customElements.define('orm-filter-dropdown', OrmFilterDropdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orm-project-solutions"] && !Shopify.designMode) return;
  try {
    
  class ProjectSolutions extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.buttons = Array.from(this.querySelectorAll('[data-panel-toggle]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.contents = Array.from(this.querySelectorAll('[data-panel-content]'));
      this.links = Array.from(this.querySelectorAll('[data-panel-link]'));
      this.defaultIndex = Number.parseInt(this.dataset.activeIndex || '0', 10);
      if (Number.isNaN(this.defaultIndex)) this.defaultIndex = 0;

      this.panels.forEach((panel, index) => {
        panel.addEventListener('pointerenter', () => {
          if (!this.hasAttribute('data-slider')) this.activate(index);
        }, { signal: this.controller.signal });
      });

      this.buttons.forEach((button, index) => {
        button.addEventListener('pointerdown', this.preventMouseActivation, { signal: this.controller.signal });
        button.addEventListener('focus', () => {
          if (!this.hasAttribute('data-slider')) this.activate(index);
        }, { signal: this.controller.signal });
      });

      this.querySelector('.orm-project-solutions__panels')?.addEventListener('pointerleave', this.restoreDefault, {
        signal: this.controller.signal,
      });
      this.addEventListener('keydown', this.handleKeydown, { signal: this.controller.signal });

      this.resizeObserver = new ResizeObserver(([entry]) => {
        this.setSliderMode(entry.contentRect.width < 990);
      });
      this.resizeObserver.observe(this);
      this.activate(this.defaultIndex);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }

    preventMouseActivation = (event) => {
      if (event.pointerType === 'mouse') event.preventDefault();
    };

    restoreDefault = () => {
      if (!this.hasAttribute('data-slider')) this.activate(this.defaultIndex);
    };

    setSliderMode(slider) {
      if (slider === this.hasAttribute('data-slider')) return;

      this.toggleAttribute('data-slider', slider);

      if (slider) {
        this.buttons.forEach((button) => {
          button.tabIndex = -1;
          button.setAttribute('aria-selected', 'false');
          button.setAttribute('aria-expanded', 'true');
        });
        this.panels.forEach((panel) => panel.classList.add('is-active'));
        this.contents.forEach((content) => content.setAttribute('aria-hidden', 'false'));
        this.links.forEach((link) => {
          link.tabIndex = 0;
        });
        return;
      }

      this.activate(this.defaultIndex);
    }

    handleKeydown = (event) => {
      if (this.hasAttribute('data-slider')) return;

      const currentIndex = this.buttons.indexOf(event.target);
      if (currentIndex < 0) return;

      const offsets = {
        ArrowLeft: -1,
        ArrowUp: -1,
        ArrowRight: 1,
        ArrowDown: 1,
        Home: -currentIndex,
        End: this.buttons.length - 1 - currentIndex,
      };
      const offset = offsets[event.key];
      if (offset === undefined) return;

      event.preventDefault();
      const nextIndex = (currentIndex + offset + this.buttons.length) % this.buttons.length;
      this.activate(nextIndex);
      this.buttons[nextIndex]?.focus();
    };

    activate(index) {
      if (!this.buttons[index]) return;

      this.dataset.activeIndex = String(index);

      this.buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === index;
        button.setAttribute('aria-selected', String(active));
        button.setAttribute('aria-expanded', String(active));
        button.tabIndex = active ? 0 : -1;
        this.panels[buttonIndex]?.classList.toggle('is-active', active);
        this.contents[buttonIndex]?.setAttribute('aria-hidden', String(!active));
        if (this.links[buttonIndex]) this.links[buttonIndex].tabIndex = active ? 0 : -1;
      });
    }
  }

  if (!customElements.get('project-solutions')) {
    customElements.define('project-solutions', ProjectSolutions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orm-promise"] && !Shopify.designMode) return;
  try {
    
  class OrmPromise extends HTMLElement {
    connectedCallback() {
      if (this.observer || this.classList.contains('is-visible')) return;

      const canAnimate =
        'IntersectionObserver' in window &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
        window.matchMedia('(min-width: 86.875rem)').matches;

      if (!canAnimate) {
        this.classList.add('is-visible');
        return;
      }

      this.classList.add('is-animation-ready');
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry?.isIntersecting) return;

          this.classList.add('is-visible');
          this.observer.disconnect();
          this.observer = null;
        },
        { threshold: 0.22 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  }

  if (!customElements.get('orm-promise')) {
    customElements.define('orm-promise', OrmPromise);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orm-reviews-page"] && !Shopify.designMode) return;
  try {
    
  class OrmReviewsPage extends HTMLElement {
    async connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.grid = this.querySelector('[data-reviews-grid]');
      this.status = this.querySelector('[data-reviews-status]');
      this.button = this.querySelector('[data-view-more]');
      this.batchSize = Number.parseInt(this.dataset.batchSize, 10) || 12;
      this.visibleCount = 0;
      if (!this.grid || !this.status || !this.button) return;

      this.button.addEventListener('click', this.showNextBatch, { signal: this.controller.signal });
      await this.loadReviews(this.controller.signal);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    async loadReviews(signal) {
      try {
        const response = await fetch(this.dataset.reviewsUrl, { signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Review request failed');

        const reviews = await response.json();
        if (!Array.isArray(reviews)) throw new Error('Review data is invalid');

        this.reviews = reviews.slice().reverse();
        this.showNextBatch();
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.status.textContent = this.dataset.errorMessage;
      }
    }

    showNextBatch = () => {
      const nextReviews = this.reviews.slice(this.visibleCount, this.visibleCount + this.batchSize);
      const fragment = document.createDocumentFragment();
      nextReviews.forEach((review) => fragment.append(this.createReviewCard(review)));
      this.grid.append(fragment);
      this.visibleCount += nextReviews.length;
      this.updateControls();
    };

    updateControls() {
      this.status.textContent = this.dataset.statusTemplate
        .replace('[visible]', this.visibleCount)
        .replace('[total]', this.reviews.length);
      this.button.hidden = this.visibleCount >= this.reviews.length;
    }

    createReviewCard(review) {
      const card = document.createElement('article');
      card.className = 'orm-reviews-page__card';
      card.dataset.reviewId = review.id;

      const rating = document.createElement('div');
      rating.className = 'orm-reviews-page__rating';
      rating.setAttribute('aria-label', `${review.rating} ${this.dataset.ratingSuffix}`);

      const stars = document.createElement('span');
      stars.className = 'orm-reviews-page__stars';
      stars.setAttribute('aria-hidden', 'true');
      for (let index = 0; index < review.rating; index += 1) {
        const star = document.createElement('img');
        star.src = this.dataset.starUrl;
        star.alt = '';
        star.width = 17;
        star.height = 16;
        stars.append(star);
      }

      const source = document.createElement('span');
      source.textContent = this.dataset.sourceLabel;
      rating.append(stars, source);

      const copy = document.createElement('div');
      copy.className = 'orm-reviews-page__copy';
      const paragraph = document.createElement('p');
      paragraph.textContent = review.review;
      copy.append(paragraph);

      const product = document.createElement('a');
      product.className = 'orm-reviews-page__product';
      product.href = review.url;
      product.target = '_blank';
      product.rel = 'noopener noreferrer';
      product.textContent = `${this.dataset.productLabel}: ${review.product}`;

      const footer = document.createElement('footer');
      footer.className = 'orm-reviews-page__footer';
      const customer = document.createElement('strong');
      customer.textContent = review.customer;
      const date = document.createElement('time');
      date.textContent = review.date;
      footer.append(customer, date);

      card.append(rating, copy, product, footer);
      return card;
    }
  }

  if (!customElements.get('orm-reviews-page')) {
    customElements.define('orm-reviews-page', OrmReviewsPage);
  }

  } catch(e) { console.error(e); }
})();
})();
